// extracted by mini-css-extract-plugin
module.exports = {"modal":"RecallModal_modal__Pvnw7"};